<script lang="ts">
	import './themeSwitcher.component.css';
	import { VpIcon } from '@vtmn-play/svelte/VpIcon';
	import { VpToggle } from '@vtmn-play/svelte/VpToggle';
	import { isDarkMode } from '../../../../stores/theme.store';
	import { _ } from '../../../../utility-services/Translation.service';

	const DARK_THEME_CLASS = 'vtmn-theme_core--dark';
	const LIGHT_THEME_CLASS = 'vtmn-theme_core--light';
	const VP_DARK_CLASS = 'vp--dark-mode';
	const VP_LIGHT_CLASS = 'vp--light-mode';
	const initialIsDarkTheme = localStorage.getItem('themeColor')?.includes(DARK_THEME_CLASS) ?? false;
	let isDarkTheme = $state(initialIsDarkTheme);

	$isDarkMode = initialIsDarkTheme;

	function changeTheme(event: Event) {
		const inputElement = event.currentTarget as HTMLInputElement | null;
		const nextIsDarkTheme = inputElement?.checked ?? !isDarkTheme;
		const htmlElement = document.querySelector('html');

		isDarkTheme = nextIsDarkTheme;
		$isDarkMode = nextIsDarkTheme;

		if (htmlElement) {
			const themeClass = nextIsDarkTheme
				? `${DARK_THEME_CLASS} ${VP_DARK_CLASS}`
				: `${LIGHT_THEME_CLASS} ${VP_LIGHT_CLASS}`;
			htmlElement.classList.value = themeClass;
			localStorage.setItem('themeColor', themeClass);
		}
	}
</script>

<div class="block">
	<div class="theme-switcher-wrapper">
		<span
			class="theme-icon"
			class:theme-label-active={!isDarkTheme}
			data-testid="theme-light-icon"
			aria-hidden="true"
		>
			<VpIcon name="sun" size={20} />
		</span>
		<VpToggle
			id="themeSwitcher"
			data-testid="inputThemeSwitcher"
			size="small"
			bind:checked={isDarkTheme}
			onchange={changeTheme}
			aria-label={isDarkTheme ? $_('dark_mode_actived') : $_('light_mode_activated')}
			aria-live="polite"
		/>
		<span
			class="theme-icon theme-icon-moon"
			class:theme-label-active={isDarkTheme}
			data-testid="theme-dark-icon"
			aria-hidden="true"
		>
			<VpIcon name="moon" size={20} />
		</span>
	</div>
</div>
